import Componentes from "../routes/components/index";
import FormularioExemplo from "../routes/formulario-exemplo";
import Tabela from "../routes/tabela";
import TabelaR from "../routes/tabela/Resizable";
import RelatorioPagamentos from "../routes/relatorios/RelatorioPagamentos";
import RelatorioPedidosPeriodo from "../routes/relatorios/RelatorioPedidosPeriodo";
import SaidaProdutos from "../routes/relatorios/SaidaProdutos";
import AuditoriaPagamentos from "../routes/relatorios/AuditoriaPagamentos";
import RelatorioParticipacao from "../routes/relatorios/RelatorioParticipacao";
import RelatorioPaisFilhos from "../routes/relatorios/RelatorioPaisFilhos";
import Coordenacao from "../routes/relatorios/Coordenacao";
import Dashboard from "../routes/relatorios/Dashboard";
import AcessosApp from "../routes/relatorios/AcessosApp";
import EventosComunidade from "../routes/perto-comunidade/evento";
import MaterialCategoria from "../routes/material-categoria/";
import Material from "../routes/material/";
import Acompanhamento from "../routes/acompanhamento";
import Ciclo from "../routes/ciclo";
import Pronuncia from "../routes/pronuncia";
import Unidade from "../routes/unidade";
import Pai from "../routes/pai";
import Professional from "../routes/professional";
import Consultor from "../routes/consultor";
import ProdutoPerto from "../routes/produto-perto";
import ProdutoPertoUsuario from "../routes/produto-perto-usuario";
import Funcao from "../routes/funcao";
import Grupo from "../routes/grupo";
import RedefinicaoSenha from "../routes/redefinicao-senha";
import Menu from "../routes/menu";
import Permissoes from "../routes/permissoes";
import Parametro from "../routes/parametro";
import Agenda from "../routes/escola/Agenda";
import ConfigPedidos from "../routes/escola/ConfigPedidos";
import Escola from "../routes/escola";
import ChavesAlunos from "../routes/chaves/Alunos";
import ChavesProfissionais from "../routes/chaves/Profissionais";
import Carteira from "../routes/carteira";
import Transportadora from "../routes/transportadora";
import GerenciamentoFretes from "../routes/pedido-gerenciamento/Fretes";
import VoucherFreteGratis from "../routes/voucher-frete-gratis";
import Carrinho from "../routes/carrinho";
import PedidosGerenciamento from "../routes/pedido-gerenciamento";
import Faturas from "../routes/faturas";
import FaturaPersonalizada from "../routes/faturas/FaturaPersonalizada";
import DashboardPagamentos from "../routes/relatorios/DashboardPagamentos";
import ProdutoCategoria from "../routes/produto-categoria";
import Produto from "../routes/produto";
import GerenciamentoPrecos from "../routes/pedido-gerenciamento/Precos";
import Promocao from "../routes/promocao";
import ClienteCfe from "../routes/cfe/cliente";
import ProfissionaisCfe from "../routes/cfe/profissional";
import IntituicaoCfe from "../routes/cfe/intituicao";
import GerenciamentoSaquesCfe from "../routes/cfe/saque/Saque";
import Chamados from "../routes/chamados";
import NovoChamado from "../routes/chamados/NovoChamado";
import Tokens from "../routes/cfe/tokens-cadastro";
import EventosPedido from "../routes/eventos-pedido";
import Home from "../routes/home/Home";
import DashboardTreinamentos from "../routes/dashboard-treinamentos/DashboardTreinamentos";
import PlanosAulas from "../routes/planos-aulas";
import Pedidos from "../routes/perto-comunidade/pedidos";
import Produtos from "../routes/perto-comunidade/produtos";
import Cadastros from "../routes/perto-comunidade/cadastros";
import TokenPagamento from "../routes/ingles-juntos/token-pagamento";
import UsuarioIj from "../routes/ingles-juntos/usuarios";
import UnidadeIj from "../routes/ingles-juntos/unidade";
import NivelIj from "../routes/ingles-juntos/nivel";
import VendasParametrosIj from "../routes/ingles-juntos/vendas/Parametros";
import PlanosIj from "../routes/ingles-juntos/plano";
import PromocaoIj from "../routes/ingles-juntos/promocao";
import AssinaturasIj from "../routes/ingles-juntos/relatorios/Assinaturas";
import AssinaturasAVencerIj from "../routes/ingles-juntos/relatorios/AssinaturasAVencer";
import PreCadastrosIj from "../routes/ingles-juntos/relatorios/PreCadastros";
import CadastrosIj from "../routes/ingles-juntos/relatorios/Cadastros";
import FinanceiroEnvioEmails from "../routes/financeiro-envios-emails";
import FinanceiroFaturasGeradas from "../routes/financeiro-faturas-geradas";
import Turma from '../routes/turma';
import PedidoLivraria from '../routes/pedido-livraria';
import NotificacoesPersonalizadas from '../routes/avisos/NotificacoesPersonalizadas';
import GrupoPreco from "../routes/grupo-preco";
import QuinzenasCarrinhos from "../routes/quinezas-carrinho";

export default [
  {
    path: "",
    component: Home,
    title: "Painel Administrativo - Perto Educação",
    exact: true,
  },
  {
    path: "components",
    component: Componentes,
  },
  {
    path: "formulario",
    component: FormularioExemplo,
  },
  {
    path: "tabela",
    component: Tabela,
  },
  {
    path: "tabela-r",
    component: TabelaR,
  },
  {
    path: "relatorio-pagamentos",
    component: RelatorioPagamentos,
    title: "Pedidos - Relatório de Pagamentos",
  },
  {
    path: "relatorio-pedidos-periodo",
    component: RelatorioPedidosPeriodo,
    title: "Pedidos - Relatório de Pedidos por Período",
  },
  {
    path: "relatorio-saida-produtos",
    component: SaidaProdutos,
    title: "Pedidos - Relatório de saída de produtos",
  },
  {
    path: "relatorio-pedidos-auditoria-pagamentos",
    component: AuditoriaPagamentos,
    title: "Pedidos - Relatório - Auditoria pagamentos",
  },
  {
    path: "relatorio-participacao",
    component: RelatorioParticipacao,
    title: "Bilíngue - Relatório de participação",
  },
  {
    path: "relatorio-pais-filhos",
    component: RelatorioPaisFilhos,
    title: "Bilíngue - Relatório de pais e filhos",
  },
  {
    path: "relatorio-coordenacao",
    component: Coordenacao,
    title: "Bilíngue - Relatório de participação (coordenadoria)",
  },
  {
    path: "comunidade-eventos",
    component: EventosComunidade,
    title: "Comunidade - Eventos",
  },
  {
    path: "material-categoria",
    component: MaterialCategoria,
    title: "Categorias de Materiais",
  },
  {
    path: "material",
    component: Material,
    title: "Materiais",
  },
  {
    path: "acompanhamento",
    component: Acompanhamento,
    title: "Bilíngue - Acompanhamento",
  },
  {
    path: "dashboard",
    component: Dashboard,
    title: "Bilíngue - Dashboard",
  },
  {
    path: "relatorio-acessos-app",
    component: AcessosApp,
    title: "Relatório - Acessos App Perto Teachers",
  },

  {
    path: "ciclo",
    component: Ciclo,
    title: "Bilíngue - Ciclo",
  },
  {
    path: "pronuncia",
    component: Pronuncia,
    title: "Bilíngue - Pronúncia",
  },
  {
    path: "unidade",
    component: Unidade,
    title: "Bilíngue - Unidade",
  },
  {
    path: "pai",
    component: Pai,
    title: "Bilíngue - Pais",
  },
  {
    path: "professional",
    component: Professional,
    title: "Bilíngue - Profissionais",
  },
  {
    path: "consultor",
    component: Consultor,
    title: "Bilíngue - Consultor",
  },
  {
    path: "produto-perto",
    component: ProdutoPerto,
    title: "Bilíngue - Produto Perto",
  },
  {
    path: "produto-perto-usuario",
    component: ProdutoPertoUsuario,
    title: "Bilíngue - Produto Perto x Usuário",
  },
  {
    path: "funcao",
    component: Funcao,
    title: "Bilíngue - Função",
  },
  {
    path: "grupo",
    component: Grupo,
    title: "Bilíngue - Grupo",
  },
  {
    path: "redefinicao-senha",
    component: RedefinicaoSenha,
    title: "Redefinição de senha",
  },
  {
    path: "menu",
    component: Menu,
    title: "Menu",
  },
  {
    path: "permissoes",
    component: Permissoes,
    title: "Permissões",
  },
  {
    path: "parametro",
    component: Parametro,
    title: "Parâmetros",
  },
  {
    path: "escola-agenda",
    component: Agenda,
    title: "Agenda",
  },
  {
    path: "escola-config-pedido",
    component: ConfigPedidos,
    title: "Configurações para pedidos",
  },
  {
    path: "escola",
    component: Escola,
    title: "Escola",
  },
  {
    path: "chaves-alunos",
    component: ChavesAlunos,
    title: "Chaves de Acesso - Alunos",
  },
  {
    path: "chaves-profissionais",
    component: ChavesProfissionais,
    title: "Chaves de Acesso - Profissionais",
  },
  {
    path: "carteira",
    component: Carteira,
    title: "Carteira",
  },
  {
    path: "transportadora",
    component: Transportadora,
    title: "Transportadoras",
  },
  {
    path: "gerenciamento-fretes",
    component: GerenciamentoFretes,
    title: "Gerenciamento de fretes",
  },
  {
    path: "voucher-frete-gratis",
    component: VoucherFreteGratis,
    title: "Vouchers de frete grátis",
  },
  {
    path: "carrinho",
    component: Carrinho,
    title: "Carrinho",
  },
  {
    path: "pedidos-gerenciamento",
    component: PedidosGerenciamento,
    title: "Pedido",
  },
  {
    path: "faturas",
    component: Faturas,
    title: "Faturas - Painel de controle",
  },
  {
    path: "fatura-personalizada",
    component: FaturaPersonalizada,
    title: "Fatura personalizada",
  },

  {
    path: "dashboard-pagamentos",
    component: DashboardPagamentos,
    title: "Pagamentos",
  },

  {
    path: "produto-categoria",
    component: ProdutoCategoria,
    title: "Categorias de produtos",
  },
  {
    path: "produto",
    component: Produto,
    title: "Produto",
  },
  {
    path: "gerenciamento-precos",
    component: GerenciamentoPrecos,
    title: "Gerenciamento de preços",
  },
  {
    path: "promocao",
    component: Promocao,
    title: "Promoção",
  },
  {
    path: "cfe-clientes",
    component: ClienteCfe,
    title: "Controle Financeiro Escolar - Clientes",
  },
  {
    path: "cfe-profissionais",
    component: ProfissionaisCfe,
    title: "Controle Financeiro Escolar - Profissionais",
  },
  {
    path: "cfe-instituicoes",
    component: IntituicaoCfe,
    title: "Controle Financeiro Escolar - Instituições",
  },
  {
    path: "cfe-gerenciamento-saques",
    component: GerenciamentoSaquesCfe,
    title: "Controle Financeiro Escolar - Gerenciamento de saques",
  },
  {
    path: "chamados",
    component: Chamados,
    title: "Solicitações",
  },
  {
    path: "novo-chamado",
    component: NovoChamado,
    title: "Nova Solicitação",
  },
  {
    path: "tokens-cadastro",
    component: Tokens,
    title: "Tokens de cadastro",
  },
  {
    path: "eventos-pedido",
    component: EventosPedido,
    title: "Eventos de pedido",
  },
  {
    path: "home",
    component: Home,
    title: "Painel Administrativo - Perto Educação",
  },
  {
    path: "dashboard-treinamentos",
    component: DashboardTreinamentos,
    title: "Dashboard de carteiras e treinamentos",
  },
  {
    path: "planos-aulas",
    component: PlanosAulas,
    title: "Plano de aulas",
  },
  {
    path: "comunidade-pedidos",
    component: Pedidos,
    title: "Comunidade - Pedidos",
  },
  {
    path: "comunidade-produtos",
    component: Produtos,
    title: "Comunidade - Produtos",
  },
  {
    path: "comunidade-cadastros",
    component: Cadastros,
    title: "Comunidade - Cadastros",
  },
  {
    path: "token-pagamento-ij",
    component: TokenPagamento,
    title: "Token de pagamento",
  },
  {
    path: "usuario-ij",
    component: UsuarioIj,
    title: "Inglês Juntos - Usuários",
  },
  {
    path: "unidade-ij",
    component: UnidadeIj,
    title: "Inglês Juntos - Unidade",
  },
  {
    path: "nivel",
    component: NivelIj,
    title: "Nível",
  },
  {
    path: "parametros-vendas-ij",
    component: VendasParametrosIj,
    title: "Parâmetros de vendas",
  },
  {
    path: "planos-ij",
    component: PlanosIj,
    title: "Planos",
  },
  {
    path: "promocao-ij",
    component: PromocaoIj,
    title: "Promoção",
  },
  {
    path: "relatorio-assinaturas-ij",
    component: AssinaturasIj,
    title: "Inglês Juntos - Relatório - Assinaturas",
  },
  {
    path: "relatorio-assinaturas-a-vencer-ij",
    component: AssinaturasAVencerIj,
    title: "Inglês Juntos - Assinaturas a vencer",
  },
  {
    path: "relatorio-pre-cadastros-ij",
    component: PreCadastrosIj,
    title: "Inglês Juntos - Relatório - Pré-cadastros",
  },
  {
    path: "relatorio-cadastros-ij",
    component: CadastrosIj,
    title: "Inglês Juntos - Relatório - Cadastros",
  },
  {
    path: "financeiro-envios-emails",
    component: FinanceiroEnvioEmails,
    title: "Registros de envios de emails",
  },
  {
    path: "financeiro-faturas-geradas",
    component: FinanceiroFaturasGeradas,
    title: "Registros de faturas geradas",
  },
  {
    path: "turmas",
    component: Turma,
    title: "Turmas",
  },
  {
    path: "pedidos-livraria",
    component: PedidoLivraria,
    title: "Pedidos (livraria)",
  },
  {
    path: "notificacoes-personalizadas",
    component: NotificacoesPersonalizadas,
    title: "Notificações Personalizadas",
  },
  {
    path: "grupo-preco",
    component: GrupoPreco,
    title: "Grupos de preços"
  },
  {
    path: "quinzenas-carrinhos",
    component: QuinzenasCarrinhos,
    title: "Quinezas - Carrinhos",
  },
];
